<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="fusing-section-separator1"></div>
    <div class="fusing-section-separator2"></div>
    <div class="fusing-container12">
      <div class="fusing-banner">
        <h1 class="fusing-text10">Glasfusing</h1>
        <span class="fusing-text11">
          Theo brandt maakt ook glasfusing. Glasfusing is een techniek die in de
          glaskunst wordt gebruikt waarbij stukjes of repen glas van dezelfde of
          verschillende kleuren samengevoegd worden door ze gedeeltelijk te
          versmelten. Glasfusing biedt zo ook de mogelijkheid om de
          verschillende kleuren van glasdelen met elkaar te laten vervloeien of
          te vermengen.
        </span>
      </div>
    </div>
    <div class="fusing-container19">
      <div class="fusing-gallery">
        <h1 class="fusing-text15">Galerij van werk</h1>
        <span class="fusing-text16">
          <span>
            <span>
              In deze galerij kunt u de fusing projecten van Theo Brandt zien.
              <span v-html="rawn714"></span>
            </span>
            <span><span v-html="rawmtty"></span></span>
          </span>
          <br />
        </span>
        <div class="fusing-container20">
          <gallery-card32
            imageSrc="/fusing/15092008009.jpg"
            title="Fam. Brandt Naambordje"
            rootClassName="rootClassName"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/Naambordje voor lichtbak.jpg"
            title="Naambordje voor lichtbak"
            rootClassName="rootClassName"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/15092008010.jpg"
            title="Huisnummer Bordje"
            rootClassName="rootClassName3"
          ></gallery-card32
          ><gallery-card32
            imageSrc="/fusing/huisnummers.jpeg"
            title="Huisnummer Bordje"
            rootClassName="rootClassName3"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/20131215_122514.jpg"
            title="Harley-Davidson Expositie"
            rootClassName="rootClassName1"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/DSC00395.JPG"
            title="Dekker Electrotechniek Naambordje"
            rootClassName="rootClassName2"
          ></gallery-card32>
          <gallery-card32
            title="Foto in glas"
            imageSrc="/fusing/DSC00411.jpeg"
            rootClassName="rootClassName4"
          ></gallery-card32>
          <gallery-card32
            title="Gefusde haantjes in glas-in-lood, ingebouwd in dubbelglas"
            imageSrc="/fusing/DSC00428.jpeg"
            rootClassName="rootClassName5"
          ></gallery-card32>
          <gallery-card32
            title="Gesmolten glas"
            imageSrc="/fusing/DSC00452.jpeg"
            rootClassName="rootClassName6"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/IMG_20210402_110002_494.jpg"
            rootClassName="rootClassName9"
            title="'t Boothuis schaal/lamp"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/FLYING Faces.jpg"
            rootClassName="rootClassName7"
            title="Flying faces"
          ></gallery-card32
          ><gallery-card32
            imageSrc="/fusing/haai.jpg"
            rootClassName="rootClassName7"
            title="Haai"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/fusingfeb2012 (10).JPG"
            rootClassName="rootClassName8"
            title="Vis"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/IMG-20160403-WA0001.jpg"
            rootClassName="rootClassName10"
            title="Dancing Sharks"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/kat25-3-2014.jpg"
            rootClassName="rootClassName11"
            title="kat"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/kickinside2.jpeg"
            rootClassName="rootClassName11"
            title="Papegaai"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/rabbitrun.jpeg"
            rootClassName="rootClassName11"
            title="Rabbitrun"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/sunface.jpeg"
            rootClassName="rootClassName11"
            title="Sunface"
          ></gallery-card32
          ><gallery-card32
            imageSrc="/fusing/twidelitie5-3-2013.JPG"
            rootClassName="rootClassName11"
            title="Twin birds"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/Geboorte schaaltje.jpg"
            rootClassName="rootClassName11"
            title="Geboorte schaaltje"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/Gezaagd glas.JPG"
            rootClassName="rootClassName11"
            title="Bord Joris Schouten"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/Tafelblad finishvlag.jpg"
            rootClassName="rootClassName11"
            title="Tafelblad finishvlag"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/Smeltoven klaar.JPG"
            rootClassName="rootClassName11"
            title="Smeltoven klaar"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/DSC00412.JPG"
            rootClassName="rootClassName11"
            title="Haantjes enkel paneel"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/fusingVis.jpeg"
            rootClassName="rootClassName11"
            title="Vis"
          ></gallery-card32>
          <gallery-card32
            imageSrc="/fusing/starbucks.jpeg"
            rootClassName="rootClassName11"
            title="Starbucks reclame bord"
          ></gallery-card32>
        </div>
      </div>
    </div>
    <div class="fusing-section-separator6"></div>
    <div class="fusing-section-separator7"></div>
    <div class="fusing-footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import BlogPostCard3 from "../components/blog-post-card3";
import BlogPostCard31 from "../components/blog-post-card31";
import GalleryCard32 from "../components/gallery-card32";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

export default {
  name: "Fusing",
  props: {},
  components: {
    BlogPostCard3,
    BlogPostCard31,
    GalleryCard32,
    Navbar,
    Footer,
  },
  data() {
    return {
      rawn714: " ",
      rawmtty: " ",
      rawdxxv: " ",
      rawxdx5: " ",
    };
  },
  metaInfo: {
    title: "Fusing - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Fusing - Langglas",
      },
    ],
  },
};
</script>

<style scoped>
.fusing-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.fusing-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}
.fusing-heading1 {
  color: #000000;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.fusing-links-container1 {
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.fusing-link10 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.fusing-link11 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.fusing-link12 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.fusing-link13 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.fusing-link14 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.fusing-link15 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.fusing-burger-menu {
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.fusing-icon1 {
  width: 36px;
  height: 36px;
}
.fusing-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: none;
  padding: var(--dl-space-space-tripleunit);
  position: absolute;
  align-items: flex-start;
  flex-direction: column;
  background-color: #fff;
}
.fusing-container11 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.fusing-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.fusing-icon3 {
  width: 24px;
  height: 24px;
}
.fusing-links-container2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.fusing-link16 {
  margin-bottom: var(--dl-space-space-unit);
}
.fusing-link17 {
  margin-bottom: var(--dl-space-space-unit);
}
.fusing-link18 {
  margin-bottom: var(--dl-space-space-unit);
}
.fusing-section-separator1 {
  width: 100%;
  height: 1px;
  display: flex;
  margin-top: var(--dl-space-space-tenunits);
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.fusing-section-separator2 {
  width: 100%;
  border: 2px dashed rgba(120, 120, 120, 0.4);
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.fusing-container12 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.fusing-banner {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.fusing-text10 {
  font-size: 3rem;
  align-self: center;
  text-align: center;
}
.fusing-text11 {
  max-width: 50%;
  margin-top: 32px;
  text-align: center;
  margin-bottom: 32px;
}
.fusing-container13 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: #f1f1f1;
}
.fusing-cta-btn1 {
  color: var(--dl-color-gray-black);
  text-align: center;
  padding-top: var(--dl-space-space-doubleunit);
  margin-right: var(--dl-space-space-unit);
  padding-left: var(--dl-space-space-tenunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-tenunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  text-decoration: none;
  background-color: var(--dl-color-gray-white);
}
.fusing-cta-btn2 {
  color: var(--dl-color-gray-black);
  text-align: center;
  font-weight: 700;
  margin-left: var(--dl-space-space-unit);
  padding-top: var(--dl-space-space-doubleunit);
  padding-left: var(--dl-space-space-tenunits);
  border-radius: var(--dl-radius-radius-radius8);
  padding-right: var(--dl-space-space-tenunits);
  padding-bottom: var(--dl-space-space-doubleunit);
  text-decoration: none;
  background-color: var(--dl-color-gray-white);
}
.fusing-text14 {
  font-weight: 700;
}

.fusing-container18 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}
.fusing-container19 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.fusing-gallery {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.fusing-text15 {
  font-size: 3rem;
  text-align: center;
}
.fusing-text16 {
  color: var(--dl-color-gray-700);
  margin-top: 32px;
  text-align: center;
  padding-left: 48px;
  margin-bottom: 32px;
  padding-right: 48px;
}
.fusing-container20 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
}
.fusing-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.fusing-footer {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  align-self: center;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: center;
}
.fusing-copyright-container {
  display: flex;
  align-self: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.fusing-icon5 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
@media (max-width: 1600px) {
  .fusing-navbar {
    width: 90%;
  }
  .fusing-container15 {
    width: 100%;
  }
  .fusing-container16 {
    width: 100%;
  }
  .fusing-container17 {
    width: 100%;
  }
  .fusing-container18 {
    width: 100%;
  }
  .fusing-footer {
    justify-content: center;
  }
}
@media (max-width: 1200px) {
  .fusing-container20 {
    grid-template-columns: 1fr 1fr;
  }
  .fusing-navbar {
    width: 100%;
  }
  .fusing-heading1 {
    margin-right: var(--dl-space-space-fourunits);
  }
  .fusing-links-container1 {
    width: auto;
    position: relative;
  }
  .fusing-link10 {
    width: auto;
    height: auto;
  }
  .fusing-link11 {
    width: auto;
    height: auto;
  }
  .fusing-link12 {
    width: auto;
    height: auto;
  }
  .fusing-link13 {
    width: auto;
    height: auto;
  }
  .fusing-link14 {
    width: auto;
  }
  .fusing-link15 {
    width: auto;
  }
}
@media (max-width: 991px) {
  .fusing-heading1 {
    text-align: center;
  }
  .fusing-links-container1 {
    width: 424px;
    display: none;
  }
  .fusing-link10 {
    width: auto;
    height: auto;
  }
  .fusing-link11 {
    width: auto;
    height: auto;
  }
  .fusing-link12 {
    width: auto;
    height: auto;
  }
  .fusing-link13 {
    width: auto;
    height: auto;
  }
  .fusing-link14 {
    width: auto;
    height: auto;
  }
  .fusing-link15 {
    width: auto;
    height: auto;
  }
  .fusing-burger-menu {
    display: flex;
  }
  .fusing-heading2 {
    text-align: center;
  }
  .fusing-text11 {
    max-width: 100%;
  }
  .fusing-text16 {
    text-align: center;
  }
  .fusing-container20 {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 840px) {
  .fusing-burger-menu {
    margin-left: var(--dl-space-space-doubleunit);
  }
  .fusing-banner {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .fusing-blog {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .fusing-gallery {
    padding: var(--dl-space-space-unit);
  }
  .fusing-container20 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: var(--dl-space-space-unit);
  }

  .gallery-card32 {
    width: 80%;
    max-width: 300px;
    margin: 0 auto;
  }
}
</style>
